import API from "../config/api.js";

export const TaskService = {
    getTaskInfo(uuid) {
        return API.get(`api/task/info/${uuid}`);
    },
    documentUpload(id, data) {
        return API.post(`api/task/${id}/upload-documents`, data);
    },
    downloadDocuments(id){
        return API.get(`api/task/download-documents/${id}`, { responseType: "blob" });
    },
    deleteDocument(id,data){
      return API.post(`api/task/${id}/delete-documents`, data);
    },
    addTaskComments(id,data){
        return API.post(`api/task/${id}/add-comments`, data);
    },
    deleteTaskComments(id,data){
      return API.post(`api/task/${id}/delete-comments`, data);
    },
    updateTaskStatus(id,data){
        return API.post(`api/task/${id}/update-status`, data);
    },
    getMembers(id){
        return API.get(`api/task/${id}/members`);
    },
    updateTaskDates(id,data){
        return API.post(`api/task/${id}/update-task-dates`, data);
    },
    getRecentTasks(filter){
        return API.get(`api/task/recent-tasks/${filter}`);
    },
    getTasksOverview(filter){
        return API.get(`api/task/statics/${filter}`);
    },
    getAuthUserRecentTasks(filter){
        return API.get(`api/task/my-recent-tasks/${filter}`);
    },
    addTaskMembers(id,data){
        return API.post(`api/task/${id}/add-task-members`, data);
    },
    deleteTaskMembers(id,data){
        return API.post(`api/task/${id}/delete-task-members`, data);
    },
    updateTaskActualHours(id,data){
        return API.post(`api/task/${id}/update-task-actual-hours`, data);
    },
    deleteTask(id){
        return API.post(`api/task/${id}/delete`);
    },
    getTaskStagesAndCategories(){
        return API.get(`api/task/get-stages-categories`);
    },
    updateTaskDetails(id,data){
        return API.post(`api/project/${id}/task/${data.uuid}/update`, data);
    },
    getMyTasks(search, project, status, stage, category, member, page=1) {
        const queryParams = [];

        queryParams.push(`se=${encodeURIComponent(search)}`);

        if (project) {
            queryParams.push(`project=${encodeURIComponent(project)}`);
          }
      
        if (status) {
          queryParams.push(`status=${encodeURIComponent(status)}`);
        }
        if (stage) {
          queryParams.push(`stage=${encodeURIComponent(stage)}`);
        }
        if (category) {
          queryParams.push(`category=${encodeURIComponent(category)}`);
        }
        if (member) {
          queryParams.push(`member=${encodeURIComponent(member)}`);
        }
    
        const queryString = queryParams.length ? `${queryParams.join('&')}?page=${page}` : '';
        return API.get(`api/task/my-tasks/${queryString}`);
    },
}